import { Deposits } from "@/modules/deposit/components";
import { DepositDetails } from "@/modules/deposit/components/DepositDetails";
import { PageHeader } from "@/shared/components";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { setActiveDepositId } from "@/shared/state/common";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const DepositsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const activeItem = useAppSelector(state => state.common);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const closeDepositDetails = () => {
    setIsOpen(false);
    dispatch(setActiveDepositId(null));
  };

  useEffect(() => {
    if (activeItem?.depositId) {
      setIsOpen(true);
    }
  }, [activeItem]);

  return (
    <>
      <div className="full-width page-container">
        <PageHeader/>
        <div className="full-width flexbox justify-content--center h-fit-content page-body">
          <div className="widget-wrapper">
            <div className="full-width mb-20">
              <Heading className="content-title" size="xsmall" weight="bolder">
                {t("deposits.title")}
              </Heading>
            </div>
            <Deposits limit={1000} depositId={activeItem?.depositId}/>
          </div>
        </div>
      </div>
      {isOpen && (
        <DepositDetails
          depositId={`${activeItem?.depositId}`}
          isOpen={isOpen}
          onClose={closeDepositDetails}
        />
      )}
    </>
  );
};
